import "./css/LincensedInsured.css";

const LicensedInsured = () => {
  return (
    <div className="licensed-banner">
      <div className="licensed-left">

        <div>
          <h3 className="licensed-title">Licensed &amp; Insured</h3>
          <p className="licensed-text">Trusted by homeowners across South Carolina</p>
        </div>
      </div>

      <div className="licensed-right">
        
      </div>
    </div>
  );
};

export default LicensedInsured;